import OkButton from "../../../../Button/OKButton/OKButton";
import { isTerminal } from "../../../../../../constants";

import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";


isTerminal ? import("./SentStatusModalTerminal.scss") : import("./SentStatusModal.scss");

const SentStatusModal = (props) => {

    const navigate = useNavigate();

    function buttonHandler(e) {
        props.close(false);
        navigate(props.route);
    }
    function navigateHandler(link) {
        if(link) {
            navigate(link)
        }
    }

    return props.sendButtonLoading ?
        <ClipLoader color="#6DCDF6" /> :
        (
            <div className="sent-status-modal">
                <div className="sent-status-modal__content">
                    <div className="sent-status-modal__head">
            заявка отправлена
                    </div>
                    <div className="sent-status-modal__description">
            Ваша заявка
                        {
                            props.requestNumber ? ` № ${props.requestNumber} ` : " "
                        }«
                        {
                            props.requestTheme
                        }
            »
            отправлена на согласование.
            Уточнить ее статус вы можете в разделе <span onClick={() => navigateHandler(props.requestLink)} style={{color: "#6DCDF6", cursor: "pointer"}}>«Заявки»</span>
                    </div>
                </div>
                <div className="sent-status-modal__button">
                    <OkButton handler={buttonHandler} title={"OK"} />
                </div>
            </div>
        );
};

export default SentStatusModal;
